import ErrorModel from '../../models/error'
import Backbone from '@polleverywhere/backbone'
import constructActivity from '../../util/construct_activity'
import { slice } from '../../apps/viz/slice'
import { slice as appSlice } from '../../slices/app'
import store from '@polleverywhere/redux'

store.addReducers({
  [slice.name]: slice.reducer
})

function updateRoute () {
  const { page } = store.getState()[appSlice.name]
  if (page !== 'viz') {
    return
  }

  const reduxState = store.getState()[slice.name]
  const route = slice.urlPath(reduxState)

  if (route) {
    this.navigate(route.path, { trigger: false, replace: !route.track })
  }
}

/**
 * Updates URL when state changes. Also, update the state model
 * from the initial route.
 */
export default class Router extends Backbone.Router {
  get routes () {
    return {
      join_instructions: () => {
        store.dispatch(slice.requestedJoinInstructions())
      },
      'leaderboards/:permalink': async (permalink) => {
        const activity = await constructActivity('competition', permalink)

        if (activity instanceof ErrorModel) {
          return store.dispatch(slice.changedActivity(null))
        }

        activity.set({ display_state: 'leaderboard' })
        store.dispatch(slice.changedActivity(activity.attributes))
      },
      ':type/:permalink': async (type, permalink) => {
        const activity = await constructActivity(type, permalink)

        if (activity instanceof ErrorModel) {
          store.dispatch(slice.requestedActivityDoesntExist())
        } else {
          store.dispatch(slice.changedActivity(activity.attributes))
        }
      }
    }
  }

  initialize (options = {}) {
    _.defaults(options, {
      updateURL: true
    })

    this.state = options.state

    // Update route based on state changes
    if (!options.updateURL) {
      return
    }

    // Listen to redux change
    store.subscribe(updateRoute.bind(this))

    // Update url on initial route.
    // We do this because this is the default route and we'll end up here before the router is even started.
    // Prior to backbone.history starting, `this.navigate` will not actually update the URL.
    // This ensures that the URL is properly updated if we're here before the router is started.
    this.listenToOnce(Backbone.history, 'route', updateRoute.bind(this))
  }
}
